import { useState } from 'react';

export interface ModalApi {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => setIsOpen(true);

  const close = () => setIsOpen(false);

  return {
    isOpen,
    open,
    close,
  };
};
